<div class="input-group">
    <!-- <input type="text" class="form-control" placeholder="" :id="elementId"
           :disabled="disabled"
           data-provide="datepicker"
           data-date-autoclose="true"
           :data-date-end-date="endDate"
           :data-date-start-date="startDate"> -->
        <input type="text" class="form-control date-picker-input" placeholder="" :id="elementId" 
            readonly
           :disabled="disabled"
           data-provide="datepicker"
           data-date-autoclose="true"
           :data-date-start-date="startDate">
    <div class="input-group-append">
        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
    </div>
</div>